import { PROFILE } from "@/data/content";
import { scrollToId } from "@/hooks/useLenis";

export const Footer = () => (
  <footer className="relative border-t-[1.5px] border-[var(--ink)] bg-[var(--ink)] text-[var(--paper)]" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div>
        <div className="pixel-title text-3xl">{PROFILE.firstName}</div>
        <div className="font-hand text-xl text-[var(--paper)]/60 mt-1">open to new work & solving problems · {PROFILE.location}</div>
      </div>
      <div className="flex flex-wrap gap-5 font-mono text-[0.65rem] tracking-[0.15em] uppercase">
        {PROFILE.socials.map((s) => (
          <a key={s.label} href={s.href} target="_blank" rel="noreferrer" className="hover:text-[var(--yellow)] transition-colors" data-testid={`footer-${s.label.toLowerCase()}`}>
            {s.label}
          </a>
        ))}
      </div>
      <button onClick={() => scrollToId("home")} className="font-mono text-[0.65rem] tracking-[0.2em] uppercase border border-[var(--paper)]/40 px-3 py-2 rounded-md hover:bg-[var(--yellow)] hover:text-[var(--ink)] hover:border-[var(--yellow)] transition-colors" data-testid="back-to-top">
        ↑ back to slate
      </button>
    </div>
    <div className="max-w-6xl mx-auto px-6 md:px-10 pb-6 font-mono text-[0.6rem] tracking-[0.2em] uppercase text-[var(--paper)]/40 flex justify-between">
      <span>© {new Date().getFullYear()} {PROFILE.name}</span>
      <span>scene end · cut</span>
    </div>
  </footer>
);
